/**
 * @generated SignedSource<<fdc3aa25e2648e822167be1fc70efd24>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatThreadActions_Recipient$data = {
  readonly id?: string;
  readonly " $fragmentSpreads": FragmentRefs<"ChatThreadEditDialog_Recipient">;
  readonly " $fragmentType": "ChatThreadActions_Recipient";
};
export type ChatThreadActions_Recipient$key = {
  readonly " $data"?: ChatThreadActions_Recipient$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatThreadActions_Recipient">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatThreadActions_Recipient",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "ChatBot",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChatThreadEditDialog_Recipient"
    }
  ],
  "type": "Recipient",
  "abstractKey": "__isRecipient"
};
})();

(node as any).hash = "81f6a66ac003f5b2f8e448bbec5103ca";

export default node;
